import type { WaterRipplePoint } from './waterScene';

type WaterRippleListener = (point: WaterRipplePoint) => void;

const listeners = new Set<WaterRippleListener>();

/**
 * Asks the desktop's water for a ripple. The water lives in its own lazily
 * loaded scene, so callers reach it through here rather than importing it;
 * with no scene listening (phones, no WebGL, still loading) nothing happens.
 */
export const requestWaterRipple = (point: WaterRipplePoint): void => {
  listeners.forEach((listener) => listener(point));
};

export const subscribeWaterRipple = (
  listener: WaterRippleListener
): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
